export default __webpack_public_path__ + "static/media/wichita5.57fc0d34.jpeg";